import UnitBetweenComparatorFilterConverter from "./UnitBetweenComparatorFilterConverter.js";
import UnitEqualsComparatorFilterConverter from "./UnitEqualsComparatorFilterConverter.js";
import UnitGreaterThanComparatorFilterConverter from "./UnitGreaterThanComparatorFilterConverter.js";
import UnitGreaterThanOrEqualComparatorFilterConverter from "./UnitGreaterThanOrEqualComparatorFilterConverter.js";
import UnitLessThanComparatorFilterConverter from "./UnitLessThanComparatorFilterConverter.js";
import UnitLessThanOrEqualComparatorFilterConverter from "./UnitLessThanOrEqualComparatorFilterConverter.js";
import UnitNotEqualsComparatorFilterConverter from "./UnitNotEqualsComparatorFilterConverter.js";
export default {
  install(molten) {
    UnitBetweenComparatorFilterConverter.create(molten);
    UnitEqualsComparatorFilterConverter.create(molten);
    UnitGreaterThanComparatorFilterConverter.create(molten);
    UnitGreaterThanOrEqualComparatorFilterConverter.create(molten);
    UnitLessThanComparatorFilterConverter.create(molten);
    UnitLessThanOrEqualComparatorFilterConverter.create(molten);
    UnitNotEqualsComparatorFilterConverter.create(molten);
  }
};